/** Phase 5C — SCR-MER-019–030 catalogue bindings (07-02) */

export const CATALOGUE_SCREEN_IDS = [
  'SCR-MER-019',
  'SCR-MER-020',
  'SCR-MER-021',
  'SCR-MER-022',
  'SCR-MER-023',
  'SCR-MER-024',
  'SCR-MER-025',
  'SCR-MER-026',
  'SCR-MER-027',
  'SCR-MER-028',
  'SCR-MER-029',
  'SCR-MER-030',
] as const;

export type CatalogueScreenId = (typeof CATALOGUE_SCREEN_IDS)[number];

export const CATALOGUE_ROUTES: Record<CatalogueScreenId, string> = {
  'SCR-MER-019': '/catalogue-overview',
  'SCR-MER-020': '/category-list',
  'SCR-MER-021': '/category-editor',
  'SCR-MER-022': '/product-list',
  'SCR-MER-023': '/product-editor',
  'SCR-MER-024': '/variant-editor',
  'SCR-MER-025': '/modifier-group-list',
  'SCR-MER-026': '/modifier-group-editor',
  'SCR-MER-027': '/allergen-editor',
  'SCR-MER-028': '/restricted-product-settings',
  'SCR-MER-029': '/bulk-import',
  'SCR-MER-030': '/branch-overrides',
};

export const CATALOGUE_PUBLISH_PERM = 'PERM-catalogue.product.publish';

export const CATALOGUE_PERMISSIONS: Partial<Record<CatalogueScreenId, readonly string[]>> = {
  'SCR-MER-019': ['PERM-catalogue.product.read'],
  'SCR-MER-020': ['PERM-catalogue.category.update'],
  'SCR-MER-021': ['PERM-catalogue.category.update'],
  'SCR-MER-022': ['PERM-catalogue.product.read'],
  'SCR-MER-023': ['PERM-catalogue.product.update'],
  'SCR-MER-024': ['PERM-catalogue.variant.update'],
  'SCR-MER-025': ['PERM-catalogue.modifier.update'],
  'SCR-MER-026': ['PERM-catalogue.modifier.update'],
  'SCR-MER-027': ['PERM-catalogue.allergen.update'],
  'SCR-MER-028': ['PERM-catalogue.restriction.update'],
  'SCR-MER-029': ['PERM-catalogue.import.execute'],
  'SCR-MER-030': ['PERM-catalogue.override.update'],
};

export const CATALOGUE_ENDPOINTS: Partial<Record<CatalogueScreenId, readonly string[]>> = {
  'SCR-MER-019': [
    'GET /merchant/v1/categories',
    'GET /merchant/v1/products',
    'GET /merchant/v1/modifier-groups',
    'POST /merchant/v1/products/{id}/publish',
  ],
  'SCR-MER-020': [
    'GET /merchant/v1/categories',
    'POST /merchant/v1/categories',
    'PATCH /merchant/v1/categories/{id}',
    'DELETE /merchant/v1/categories/{id}',
    'POST /merchant/v1/categories/reorder',
  ],
  'SCR-MER-021': [
    'GET /merchant/v1/categories',
    'POST /merchant/v1/categories',
    'PATCH /merchant/v1/categories/{id}',
  ],
  'SCR-MER-022': [
    'GET /merchant/v1/products',
    'GET /merchant/v1/categories',
    'POST /merchant/v1/products/bulk',
  ],
  'SCR-MER-023': [
    'GET /merchant/v1/products/{id}',
    'POST /merchant/v1/products',
    'PATCH /merchant/v1/products/{id}',
    'DELETE /merchant/v1/products/{id}',
    'GET /merchant/v1/categories',
    'GET /merchant/v1/modifier-groups',
    'GET /merchant/v1/products/{id}/history',
    'GET /merchant/v1/products/{id}/conflict',
  ],
  'SCR-MER-024': [
    'GET /merchant/v1/products/{id}/variants',
    'POST /merchant/v1/products/{id}/variants',
    'POST /merchant/v1/products/{id}/variants/reorder',
    'PATCH /merchant/v1/variants/{id}',
    'DELETE /merchant/v1/variants/{id}',
    'PUT /merchant/v1/variants/{id}/prices',
  ],
  'SCR-MER-025': [
    'GET /merchant/v1/modifier-groups',
    'POST /merchant/v1/modifier-groups',
    'PATCH /merchant/v1/modifier-groups/{id}',
    'DELETE /merchant/v1/modifier-groups/{id}',
  ],
  'SCR-MER-026': [
    'GET /merchant/v1/modifier-groups',
    'POST /merchant/v1/modifier-groups',
    'PATCH /merchant/v1/modifier-groups/{id}',
    'POST /merchant/v1/modifier-groups/{id}/options',
    'PATCH /merchant/v1/modifier-options/{id}',
  ],
  'SCR-MER-027': ['GET /merchant/v1/products/{id}', 'PUT /merchant/v1/products/{id}/allergens'],
  'SCR-MER-028': ['GET /merchant/v1/products/{id}', 'PUT /merchant/v1/products/{id}/restrictions'],
  'SCR-MER-029': [
    'GET /merchant/v1/catalogue/exports',
    'POST /merchant/v1/catalogue/imports',
    'GET /merchant/v1/catalogue/imports/{id}',
    'GET /merchant/v1/catalogue/imports/{id}/errors',
    'POST /merchant/v1/catalogue/imports/{id}/commit',
  ],
  'SCR-MER-030': [
    'GET /merchant/v1/branches',
    'GET /merchant/v1/products/{id}',
    'GET /merchant/v1/products/{id}/variants',
    'PUT /merchant/v1/branches/{id}/catalogue-overrides',
    'GET /merchant/v1/branches/{id}/catalogue-overrides',
    'PUT /merchant/v1/variants/{id}/prices',
    'GET /merchant/v1/products',
    'GET /merchant/v1/branches/{id}/availability',
  ],
};

export const PRODUCT_ID_STORAGE_KEY = 'beatq.merchant.productId';
export const CATEGORY_ID_STORAGE_KEY = 'beatq.merchant.categoryId';
export const MODIFIER_GROUP_ID_STORAGE_KEY = 'beatq.merchant.modifierGroupId';

export const COMMON_ALLERGENS = [
  'CELERY',
  'CRUSTACEANS',
  'EGGS',
  'FISH',
  'GLUTEN',
  'LUPIN',
  'MILK',
  'MOLLUSCS',
  'MUSTARD',
  'NUTS',
  'PEANUTS',
  'SESAME',
  'SOYA',
  'SULPHITES',
] as const;
